import { observer } from 'mobx-react'
import './index.scss'

import classNames from 'classnames'

const ProductItem = observer(({ isDark, dt }: { isDark: boolean; dt: any }) => {
  return (
    <a className={classNames('product-item', isDark && 'dark')} href={dt.link}>
      <img className="product-item__icon" src={dt.icon} />
      <div
        className="product-item__title"
        dangerouslySetInnerHTML={{ __html: dt.title }}
      ></div>
      <div className="product-item__text">
        {dt.subtitle && (
          <span className="product-item__text main">{dt.subtitle}</span>
        )}
        {dt.text}
      </div>
      {dt.comment.length ? (
        <div className="product-item__comment">{dt.comment}</div>
      ) : (
        <></>
      )}
      <div className="product-item__list">
        {dt.icons.map((d: any, i: number) => (
          <img className="product-item__sub-icon" src={d} key={i} />
        ))}
      </div>
    </a>
  )
})

export default ProductItem
